"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
const Party_vue_1 = __importDefault(require("@/client/components/Party.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'SelectParty',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            selectedParty: undefined,
        };
    },
    components: {
        AppButton: AppButton_vue_1.default,
        Party: Party_vue_1.default,
    },
    methods: {
        saveData() {
            if (this.selectedParty === undefined) {
                return;
            }
            this.onsave({ type: 'party', partyName: this.selectedParty });
        },
        isDominant(partyName) {
            return partyName === this.turmoil?.dominant;
        },
        partyAvailableToSelect(partyName) {
            if (this.playerinput.parties === undefined) {
                return false;
            }
            else {
                return this.playerinput.parties.includes(partyName);
            }
        },
    },
    computed: {
        turmoil() {
            return this.playerView.game.turmoil;
        },
    },
});
